module.exports = __webpack_public_path__ + "img/logo-ticketshop.ca82ecc6.png";